module.exports = __webpack_public_path__ + "static/parallelogram-web-light-blue-a3d8c674c1ae7d71223ef204b749c5f9.png";